import { render, staticRenderFns } from "./CardSection.vue?vue&type=template&id=d8a0a9ae&"
import script from "./CardSection.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CardSection.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8a0a9ae')) {
      api.createRecord('d8a0a9ae', component.options)
    } else {
      api.reload('d8a0a9ae', component.options)
    }
    module.hot.accept("./CardSection.vue?vue&type=template&id=d8a0a9ae&", function () {
      api.rerender('d8a0a9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/ethical-commission/meetings/components/MainContent/components/MeetingCard/components/CardSection.vue"
export default component.exports